'use client'

import { ConfigContext, useTranslation } from '../../../context/ConfigContext'
import { useContext } from 'react'
import Icon from '../../Icon/Icon'
import { Icons } from '../../Icon/constants'

type FilterProductFormMobileMenuProps = {
  openFilterModal: () => void
  openOrderModal: () => void
}

const FilterProductFormMobileMenu = ({
  openFilterModal,
  openOrderModal,
}: FilterProductFormMobileMenuProps) => {
  const { storeConfig } = useContext(ConfigContext)
  const t = useTranslation()
  return (
    <div className='filter-product-form-menu'>
      <button
        onClick={openFilterModal}
        type='button'
        className='filter-product-form-filterby-button'>
        <span>{t('Filter by')} </span>
        <Icon iconName={Icons.NAV_ARROW_DOWN} />
      </button>
      {storeConfig.display_prices === 1 && (
        <button
          onClick={openOrderModal}
          type='button'
          className='filter-product-form-orderby-button'>
          <span>{t('SORT BY')} </span>
          <Icon iconName={Icons.FILTER_LIST} />
        </button>
      )}
    </div>
  )
}

export default FilterProductFormMobileMenu
